import * as React from "react";
import glamorous from "glamorous";
import { Segment, Grid, Header } from "semantic-ui-react";
import { Link as RRLink } from "react-router-dom";

import Connector from "../Jigsaw/Connector";
import CenterQuadNavigation from "../CenterQuadNavigation";
import { Connectors } from "../SubQuadNavigation/Connectors/Connectors";
import { Container } from "../Piece/styles";

export interface QuadrantNavigationProps {}

const Link = glamorous(RRLink)({
	textDecoration: "unset",

	color: "black",
	":visited": {
		color: "unset"
	},
	":hover": {
		color: "unset"
	}
});

//Taken from Semantic, to colour the Jigsaw connectors.
const GREEN = "#21ba45";
const YELLOW = "#fbbd08";
const BLUE = "#2185d0";
const RED = "#db2828";

interface QuadProps {
	/** What is the colour of the Quad? */
	colour: "green" | "red" | "yellow" | "blue";
	/**What is the title of this quad? */
	title: string;
	/** What should be the smaller text? */
	caption: string;
	/** Where should clicking on this take the user? */
	to: string;

	up?: boolean;
	down?: boolean;
	left?: boolean;
	right?: boolean;
}

const getHex = str => {
	switch (str) {
		case "green":
			return GREEN;
		case "blue":
			return BLUE;
		case "yellow":
			return YELLOW;
		case "red":
			return RED;
		default:
			return "#9370db";
	}
};

const Quad = (props: QuadProps) => (
	<Link to={props.to}>
		{props.up && (
			<Connectors.Up colour={getHex(props.colour)} height={50} />
		)}
		<Container
			height={NAVIGATION_HEIGHT / 2 + "px"}
			colour={getHex(props.colour)}
			style={{
				border: 0
				// color: getColor(props.colour)
			}}
		>
			{props.left && (
				<Connectors.Left height={50} colour={getHex(props.colour)} />
			)}
			<div
				style={{
					flexGrow: 1,
					justifyContent: "center",
					alignItems: "center",
					alignSelf: "stretch",
					display: "flex",
					flex: "1 0 100%",
					right: props.left ? "54px" : "0",
					position: props.left ? "relative" : "initial"
				}}
			>
				<div
					style={{
						flex: "1",
						padding: "0 50px",
						textAlign: "center",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center"
					}}
				>
					<Header> {props.title}</Header>
					<p>{props.caption}</p>
				</div>
			</div>
			{props.right && (
				<Connectors.Right height={50} colour={getHex(props.colour)} />
			)}
		</Container>
		{props.down && (
			<Connectors.Down colour={getHex(props.colour)} height={50} />
		)}
	</Link>
);

const NAVIGATION_HEIGHT = 600;

const QuadrantNavigation: React.SFC<QuadrantNavigationProps> = props => (
	<Grid columns={2} style={{ height: NAVIGATION_HEIGHT, marginBottom: 24 }}>
		<Grid.Row style={{ height: NAVIGATION_HEIGHT / 2 }}>
			<Grid.Column style={{ padding: 0 }}>
				<Quad
					colour="green"
					title="Owners Profile"
					caption="Who you are and what do you want out of your business?"
					to="/owners"
					down
				/>
			</Grid.Column>
			<Grid.Column style={{ padding: 0 }}>
				<Quad
					left
					colour="red"
					title="Business Strategy"
					caption="What,where, and how do you compete?"
					to="/strategy"
				/>
			</Grid.Column>
		</Grid.Row>

		<Grid.Row style={{ height: NAVIGATION_HEIGHT / 2 }}>
			<Grid.Column style={{ padding: 0 }}>
				<Quad
					colour="yellow"
					title="Operations & Admin"
					caption="What operational, financial, and administration things do you need to do to run your business successfully?"
					to="/operations"
					right
				/>
			</Grid.Column>
			<Grid.Column style={{ padding: 0 }}>
				<Quad
					colour="blue"
					title="Marketing"
					caption="How do you identify, your target market and reach it?"
					to="/marketing"
					up
				/>
			</Grid.Column>
		</Grid.Row>
		<CenterQuadNavigation />
	</Grid>
);

export default QuadrantNavigation;



// WEBPACK FOOTER //
// ./src/components/QuadrantNavigation/QuadrantNavigation.tsx